
import React, { useEffect, useState } from 'react';
import { Checkbox } from 'office-ui-fabric-react/lib/Checkbox';
import { Dropdown } from 'office-ui-fabric-react/lib/Dropdown';
import { TextField } from 'office-ui-fabric-react/lib/TextField';
import { mergeStyleSets } from 'office-ui-fabric-react/lib/Styling';

import { 
    PanelSectionTitle, 
    utils 
} from '../../core';

const PrintOptions = (props) => {

    const classNames = mergeStyleSets({
        root: {
        },
        checkbox: {
            paddingBottom: 2
        }
    });

    const [options, setOptions] = useState({});

    useEffect(() => {
        setOptions(props.options);
    }, [props])

    const handleChange = (name, checked) => {
        let newOptions = {
            ...options,
            [name]: checked
        };
        props.onChange(newOptions);
        setOptions(newOptions);
    }

    return (
        <div className={classNames.root}>
            <PanelSectionTitle title="Možnosti pro tisk" />
            <div className={classNames.checkbox}>
                <Checkbox
                    label="Tisknout mapu"
                    checked={(options.printMap === true) && (props.visibleMap)}
                    disabled={props.disabled || !props.visibleMap}
                    onChange={(event, checked) => {
                        handleChange('printMap', checked);
                    }}
                />
            </div>
            <div className={classNames.checkbox}>
                <Checkbox
                    label="Tisknout 3D okno"
                    checked={(options.printMultiScene === true) && (props.visibleMultiScene)}
                    disabled={props.disabled || !props.visibleMultiScene}
                    onChange={(event, checked) => {
                        handleChange('printMultiScene', checked);
                    }}
                />
            </div>
            <Dropdown
                placeholder="Vyberte formát stránky"
                label="Fomát stránky"
                disabled={props.disabled}
                selectedKey={options.orientation}
                options={[
                    {key: 'p', text: 'Na výšku'},
                    {key: 'l', text: 'Na šířku'}
                ]}
                onChange={(event, item) => {
                    handleChange('orientation', item.key);
                }}
                styles={utils.styles.DROPDOWN_STYLES}
            />
            <TextField
                disabled={props.disabled}
                label="Nadpis"
                onChange={(event) => {
                    handleChange('title', event.target.value);
                }}
                styles={utils.styles.TEXT_BOX_STYLES}
                value={options.title}
            />
        </div>
    );
}

export default PrintOptions;
